import useMediaQuery from "~/common/hooks/useMediaQuery";
import { MEDIA_QUERY_MIN_DESKTOP_S } from "~/common/utils/screenSizes";
import { type PdpPageProductData } from "~/features/productDetails/models/PdpPageProductData";
import { resolveUrl } from "~/utils/url/urlResolver";

interface CalculationTabProps {
  product: PdpPageProductData;
}

export const ConfiguratorTab = (props: CalculationTabProps) => {
  const { product } = props;

  const isDesktop = useMediaQuery(MEDIA_QUERY_MIN_DESKTOP_S);

  const configuratorUrl = resolveUrl(`/lmbt-configurator/${product.lmbtConfigurator}`);

  return (
    <div className={"scha__ignore-margins " + (isDesktop ? undefined : "w-100")}>
      <iframe className="scha__pdp-iframe" id="configuratorIframe" scrolling="yes" src={configuratorUrl}></iframe>
    </div>
  );
};
